





















































































































// require('./lib/ui/root.js');

import ripple from "../../components/ripple.vue"
import tooltip from "../../components/tooltip.vue"
import gbutton from "../../components/button.vue"
import graph from "../../components/graph.vue"
import dropdown, { DropdownInterface, DropdownItem } from "../../components/dropdownMenu.vue"
import dateSelector from "../../components/dateSelector.vue"

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { setInterval } from "timers";
import DropdownMenu from "../../components/dropdownMenu.vue";
import moment,{ weekdays, Moment } from "moment";

import {frontendClient} from "../../lib/client";
import {HTTPPostAPI} from "../../lib/httpapi"

@Component({
    components : {
        ripple,
        gbutton,
        dropdown,
        graph,
        dateSelector,
        tooltip,
    },
})
export default class Graphs extends Vue{
    fromSelector:boolean = false;
    toSelector:boolean = false;

    frontendClient = frontendClient;

    moment = moment;
    myGraph = null;

    openMore:boolean = false;
    
    range:{
        from:number,
        to:number
    } = {
        from: new Date().setHours(0,0,0,0),
        to: new Date().setHours(23,59,59,59)
    };

    searchVal:string = null;

    getDates(){
        this.range.from = moment(this.range.to).subtract(7, 'days').toDate().setHours(0,0,0,0);
    }

    redirect(route,parameters?){
        if(parameters){
            this.$router.replace({ name: route, params: parameters});
        }else{
            this.$router.push({ name: route, params: parameters});
        }
    };

    // date selectors
    openFromSelector(x){
        this.fromSelector = true;
    }
    openToSelector(x){
        this.toSelector = true;
    }
    closeFrom(x){
        this.fromSelector = false;
    }
    closeTo(x){
        this.toSelector = false;
    }
    closeRanges(){
        this.fromSelector = false;
        this.toSelector = false;
    }

    mounted(){
       this.$emit('scope','clients'); // FIXME: should scope really be `clients`?
       this.getDates();
       this.updateGraphs();
       this.getUnpaidList();
    }

    unpaidJobs: void | HTTPPostAPI["jobs/usergroups/unpaid/list"]["result"] = {
        list: [],
        totalHours: 0,
    };
    async getUnpaidList() {
        this.unpaidJobs =  {
            list: [],
            totalHours: 0,
        };
        
        this.unpaidJobs = await frontendClient.post("jobs/usergroups/unpaid/list",{
            userID: this.frontendClient.userData.userID,
        }).catch((err) => {
            console.log(err);
        });
    }
    
    async updateGraphs(){
        this.myGraph = await frontendClient.post("graph/stats",{
            from: this.range.from,
            to: this.range.to,
        })
    }
}
